import { onFirstInteraction } from "./firstInteraction";

const TC_ID = "ti-js";
const TC_SRC = "//app.truconversion.com/ti-js/63556/60922.js";

// The queue must exist before the script loads so identity pushes made during
// the gesture wait are drained on load rather than lost.
if (typeof window !== "undefined") window._tip = window._tip || [];

function inject() {
  if (document.getElementById(TC_ID)) return;

  const js = document.createElement("script");
  js.id = TC_ID;
  js.async = true;
  js.src = window.location.protocol + TC_SRC;

  const first = document.getElementsByTagName("script")[0];
  if (first && first.parentNode) first.parentNode.insertBefore(js, first);
  else document.head.appendChild(js);
}

// Deferred to the first user gesture (Home invariant #7). TruConversion's
// recorder hooks pointer/scroll/mutation events and streams session data, so
// loading it at boot puts third-party main-thread work + XHRs in every
// Lighthouse trace. Bots never gesture; real visitors trigger it on their
// first scroll or pointer move, before any behaviour worth recording happens.
//
// ?tc=1 loads it immediately: TruConversion's "Verify Installation" opens the
// site in a blank window and looks for the script without ever gesturing.
export default function initTruConversion() {
  if (process.env.NODE_ENV !== "production") return;

  if (new URLSearchParams(window.location.search).get("tc") === "1") inject();
  else onFirstInteraction(inject);
}

export function trackIdentity(id) {
  if (process.env.NODE_ENV !== "production" || !id) return;
  window._tip.push(["_trackIdentity", id]);
}

// Fires a named TruConversion trigger. Funnel steps that have no URL of their
// own (form submits, in-page wizard steps) are configured in the dashboard as
// "Javascript Trigger" steps and complete when the matching name fires here.
// tcjs only exists once the loader has run, which is always true by the time a
// user has filled in a form.
// Never throws: every call site sits inside the try block of a submit handler, so
// a throw from the vendor script would be caught there and reported to the user as
// a failed submission even though their data was already saved.
export function trackTrigger(name) {
  if (process.env.NODE_ENV !== "production" || !name) return;
  if (typeof window.tcjs !== "function") return;
  try {
    window.tcjs("trigger", "cf", name);
  } catch (e) {
    console.warn("TruConversion trigger failed:", name, e);
  }
}
